import type { TranscriptSource } from "../../shared/types.ts";

/** Human-readable name for the active suggestion provider or the model that produced a card. */
export function providerLabel(name: string): string {
  const n = name.trim().toLowerCase();
  if (n === "mock" || n === "rule-based") return "rule-based";
  if (n === "groq") return "Groq";
  if (n.startsWith("groq:")) {
    const model = name.slice(name.indexOf(":") + 1).replace(/^openai\//, "");
    return model ? `Groq ${model}` : "Groq";
  }
  if (n === "local-llm") return "local LLM";
  return name;
}

/** Human-readable name for the current transcript input. The old "mock" source
 * is sample-injection, not a real input mode. */
export function sourceLabel(source: TranscriptSource): string {
  switch (source) {
    case "mic":
      return "mic";
    case "manual":
      return "manual";
    case "stt":
      return "cloud STT";
    case "mock":
      return "sample";
    default:
      return source;
  }
}

export function fmtTime(ts: number): string {
  return new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

// Stable per-speaker colour so diarized speakers (Speaker 1/2/…, Panelist A, Mic)
// are visually distinct in the transcript. Palette is drawn from the theme accents.
const SPEAKER_COLORS = [
  "#b39dff", // violet
  "#5fd6a0", // jade
  "#e8c069", // gold
  "#ffacbf", // pink
  "#7cc4ff", // sky
  "#d89a72", // clay
  "#c9a9ff", // lilac
  "#9fe6c0", // mint
];

export function speakerColor(name: string, seed?: string | null): string {
  const colorSeed = seed?.trim() || name;
  let h = 0;
  for (let i = 0; i < colorSeed.length; i++) h = (h * 31 + colorSeed.charCodeAt(i)) >>> 0;
  return SPEAKER_COLORS[h % SPEAKER_COLORS.length];
}
